// extracted by mini-css-extract-plugin
export default {"main-container":"CRMCallback_main-container__7OCKL"};